import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";

const BrandDetails: React.FC = () => {
  const context = useContext(ProductContext);

  if (!context?.product) return null;

  const { brandDetails, headingColor, textColor, headingFontStyle, fontStyle } = context.product;

  return (
    <>
      {brandDetails && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Brand Details
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {brandDetails}
          </p>
        </div>
      )}
    </>
  );
};

export default BrandDetails;
